var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.447 0 0 0.448953 0 1.00195L0.00195312 4.38281C0.00195312 4.76181 0.215688 5.10834 0.554688 5.27734L7.55469 8.77734C7.6939 8.84646 7.84503 8.88191 7.99609 8.88281C7.99803 8.88282 8.00002 8.88281 8.00195 8.88281C8.15495 8.88281 8.30627 8.84834 8.44727 8.77734L15.4473 5.27734C15.7863 5.10834 16.002 4.76181 16.002 4.38281L16 1C15.999 0.447 15.552 0 15 0H1ZM7.99609 8.88281C7.80809 8.88281 7.61998 8.97983 7.52149 9.17383L5.94531 12.2559L2.46094 12.7422C2.01694 12.8042 1.84097 13.3532 2.16797 13.6602L4.67578 16.0176L4.08008 19.3711C4.00308 19.8051 4.45466 20.1404 4.84766 19.9414L7.99609 18.3438L11.1445 19.9414C11.5375 20.1404 11.9891 19.8051 11.9121 19.3711L11.3164 16.0176L13.8242 13.6602C14.1502 13.3532 13.9753 12.8042 13.5312 12.7422L10.0469 12.2559L8.4707 9.17383C8.3712 8.97983 8.18409 8.88281 7.99609 8.88281ZM5.99805 2H9.99805V5.76562L8.00195 6.76367L5.99805 5.76172V2Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/Reward.5c8119dd4f1c0106014cddd5a70dd3d3.svg";
export { ForwardRef as ReactComponent };